import React from 'react'
import PropTypes from 'prop-types'
import { Container, Flex, FloraTypography, Spinner } from '@grupoboticario/flora-react'

const FullPageLoader = ({ text }) => {
  return (
    <Flex align='center' justify='center' css={{ height: '100vh' }}>
      <Container centerContent size='large'>
        <Spinner size='md' />
        <Flex css={{ marginTop: '$4' }}>
          {text && (
            <FloraTypography fontSize='bodyLargeStandard' as='h1'>
              {text}
            </FloraTypography>
          )}
        </Flex>
      </Container>
    </Flex>
  )
}

FullPageLoader.propTypes = {
  text: PropTypes.string
}

FullPageLoader.defaultProps = {
  text: ''
}

export default FullPageLoader
